// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("../../next/Next.bs.js");
var DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var EventLogs = require("../../EventLogs.bs.js");
var ViewStack = require("../ViewStack.bs.js");
var Text__Jsx3 = require("../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
var AuthSession = require("../../../utils/AuthSession.bs.js");
var UserSession = require("../UserSession/UserSession.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function TerminatedAccountOverlay$ForceActivateDialog(props) {
  var logout = props.logout;
  return JsxRuntime.jsxs(DialogV5.make, {
              title: "Your Subscription is Inactive",
              isOpen: true,
              ariaLabel: "Your subscription is inactive",
              onDismiss: (function (prim) {
                  
                }),
              showCloseButton: false,
              children: [
                JsxRuntime.jsxs(Text__Jsx3.make, {
                      lineHeight: {
                        NAME: "float",
                        VAL: 1.5
                      },
                      children: [
                        "You no longer have an active TAN subscription. Please go to your billing settings if you wish to reactivate it.",
                        JsxRuntime.jsx("br", {}),
                        JsxRuntime.jsx("br", {}),
                        "If you have another account that is active you can log out and use that one instead."
                      ]
                    }),
                JsxRuntime.jsx(View__Jsx3.make, {
                      mt: "md"
                    }),
                JsxRuntime.jsxs(ViewStack.make, {
                      justifyContent: "flexEnd",
                      flexDirection: "row",
                      children: [
                        JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                              onClick: (function (param) {
                                  logout();
                                }),
                              children: "Log Out"
                            }),
                        JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                              href: "/subscribe",
                              children: "Reactivate Your Account"
                            })
                      ]
                    })
              ]
            });
}

var ForceActivateDialog = {
  make: TerminatedAccountOverlay$ForceActivateDialog
};

function TerminatedAccountOverlay(props) {
  var router = Next.useRouter();
  var pathname = Next.Router.pathname(router);
  var recordEvent = EventLogs.useRecordEventByCurrentUser();
  var logout = function () {
    recordEvent(undefined, "Logout", undefined);
    AuthSession.logout();
  };
  var isOnAccountSettingsPage = Next.Router.asPath(router).startsWith("/account/billing");
  var isPageAllowed = isOnAccountSettingsPage || pathname === "/subscribe";
  var agent = UserSession.useAgentInfo();
  var tmp = agent.membership.account.accountStatus;
  if ((tmp === "ACTIVE" || tmp === "TERMINATED") && !(tmp === "ACTIVE" || isPageAllowed)) {
    return JsxRuntime.jsx(TerminatedAccountOverlay$ForceActivateDialog, {
                logout: (function () {
                    logout();
                  })
              });
  } else {
    return null;
  }
}

var make = TerminatedAccountOverlay;

var $$default = TerminatedAccountOverlay;

exports.ForceActivateDialog = ForceActivateDialog;
exports.make = make;
exports.default = $$default;
exports.__esModule = true;
/* Next Not a pure module */
